<template>
  <div>
    <div class="row" v-if="declaration">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <form class="float-right">
              <a target="_blank" type="button" class="btn btn-link ml-2" v-if="pdf" :href="`/api/declarations/${id}/documents/${pdf.id}`">
                <i class="mdi mdi-file-pdf"></i> PDF
              </a>
              <a target="_blank" type="button" class="btn btn-link ml-2" v-if="ead" :href="`/api/declarations/${id}/documents/${ead.id}`">
                <i class="mdi mdi-file-pdf"></i> EAD
              </a>
              <button type="button" class="btn btn-info ml-1" @click="changeClient" v-if="declaration.clientChangeAllowed">
                <i class="mdi mdi-edit"></i>Määra klient
              </button>
              <button type="button" class="btn btn-secondary ml-1 delete-declaration" @click="deleteDeclaration" v-if="declaration.canBeDeleted">
                <i class="mdi mdi-delete"></i> Kustuta
              </button>
            </form>
          </div>
          <h4 class="page-title">Deklaratsioon {{declaration.customsReference}} </h4>
        </div>
      </div>
    </div>

    <div v-if="declaration">
      <div class="card generic-details">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-2">Üldandmed</h4>
          <div class="row">
            <div class="col">
              <div class="data-list">
                <dl>
                  <dt>Klient</dt>
                  <dd class="client-name">{{declaration.clientName}}</dd>
                </dl>
                <dl>
                  <dt>Imporditud</dt>
                  <dd class="declaration-date">{{declaration.date | formatDate}}</dd>
                </dl>
                <dl>
                  <dt>Aktsepteeritud</dt>
                  <dd class="declaration-accepted-date"><span v-if="declaration.acceptedAt">{{declaration.acceptedAt | formatDate}}</span></dd>
                </dl>
              </div>
            </div>
            <div class="col">
              <div class="data-list">
                <dl>
                  <dt>Viitenumber</dt>
                  <dd class="declaration-reference">{{declaration.reference}}</dd>
                </dl>
                <dl>
                  <dt>Staatus</dt>
                  <dd class="declaration-status">{{declaration.status}}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col declaration-invoice-details">
          <declaration-invoicing-details :declaration="declaration"/>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <h4 class="header-title pt-1 pb-1">Algdokumendid</h4>
          <table v-if="documents.length" class="table table-centered table-sm table-striped">
            <thead>
            <tr>
              <th>Nimi</th>
              <th>Kasutaja</th>
              <th>Üles laetud</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="document in documents">
              <td>
                <a target="_blank" :href="`/api/declarations/${id}/documents/${document.id}`">
                  {{document.fileName}} <i class="mdi mdi-download"></i>
                </a>
              </td>
              <td>{{document.createdBy || 'custi'}}</td>
              <td>{{document.createdAt | formatDateTime}}</td>
              <td class="table-action text-nowrap pr-0">
                <permission name="DeclarationDocumentDelete">
                  <a @click.prevent="deleteDocument(document)" class="btn btn-link">
                    <i class="mdi mdi-delete"></i>
                  </a>
                </permission>
              </td>
            </tr>
            </tbody>
          </table>
          <file-drop v-model="selectedFile" :in-progress="uploading" label="Lisa dokument"/>
        </div>
      </div>

      <div class="card">

        <div class="card-body">
          <h4 class="header-title pt-1 pb-1" @click="showRaw=!showRaw">
            Algandmed
            <i class="float-right mdi" style="font-size: 150%" :class="{'mdi-chevron-right': !showRaw, 'mdi-chevron-left': showRaw}"></i>
          </h4>
          <div class="row" v-if="showRaw">
            <div class="col">
              <pre>{{raw}}</pre>
            </div>
          </div>
        </div>
      </div>

    </div>

    <modal ref="changeClientModal" size="lg" title="Määra klient" @ok="loadDeclaration()">
      <change-client :declaration="declaration" slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>
  </div>
</template>

<script>
  import DeclarationInvoicingDetails from '@/components/declaration/DeclarationInvoicingDetails'
  import ChangeClient from '@/components/declaration/ChangeClient'
  import Modal from '@/components/Modal'
  import FileDrop from '../components/FileDrop'

  export default {
    props: ['id'],
    components: {DeclarationInvoicingDetails, ChangeClient, Modal, FileDrop},
    data() {
      return {
        declaration: null,
        raw: null,
        showRaw: false,
        documents: [],
        pdf: null,
        ead: null,

        fileName: null,
        dataUrl: null,
        selectedFile: null,
        uploading: false
      }
    },
    methods: {
      loadDeclaration() {
        this.$gateway.get(`/declarations/${this.id}`).then(r => this.declaration = r.data)
      },
      loadDocuments() {
        this.$gateway.get(`/declarations/${this.id}/documents`).then(r => {
          this.documents = this.generalDocuments(r.data);
          this.pdf = this.declarationPdf(r.data)
          this.ead = this.declarationEad(r.data)
        })
      },
      generalDocuments(documents) {
        return documents.filter(d => d.category !== 'COMPLEX22' && d.category !== 'COMPLEX24');
      },
      declarationPdf(documents) {
        let pdfs = documents.filter(d => d.category === 'COMPLEX22');
        return pdfs.length ? pdfs[0] : null;
      },
      declarationEad(documents) {
        let eads = documents.filter(d => d.category === 'COMPLEX24');
        return eads.length ? eads[0] : null;
      },
      deleteDocument(document) {
        this.$confirm(`Kas soovid kustutada dokumenti ${document.fileName}?`, () => {
          this.$gateway.delete(`/declarations/${this.id}/documents/${document.id}`).then(this.loadDocuments)
        })
      },
      loadRaw() {
        this.$gateway.get(`/declarations/${this.id}/raw`).then(r => this.raw = r.data)
      },
      changeClient() {
        this.$refs.changeClientModal.show()
      },
      deleteDeclaration() {
        this.$confirm(`Kustutame deklaratsiooni tolliviitega ${this.declaration.customsReference} ?`, () => {
          this.$gateway.delete(`/declarations/${this.declaration.id}`).then(() => {
            this.$notifications.info(`Deklaratsioon ${this.declaration.customsReference} on kustutatud`)
            this.$router.replace('/declarations')
          })
        })
      },
      readFile(file) {
        let component = this
        let reader = new FileReader();

        this.fileName = file.name

        const promise = new Promise((resolve, reject) => {
          if (file.size > 20 * 1024 * 1024) {
            reject('Fail on liiga suur. Lubatud on kuni 20 MB')
            return
          }
          reader.onload = () => {
            component.dataUrl = reader.result;
            file.value = ''
            resolve(this.fileName)
          }
        })

        reader.readAsDataURL(file)
        return promise;
      },
    },
    watch: {
      id() {
        this.loadDeclaration()
        this.loadDocuments()
        this.loadRaw()
      },
      selectedFile(newValue) {
        this.readFile(newValue).then((r) => {
          this.uploading = true
          this.$gateway
            .post(`/declarations/${this.id}/documents`, {content: this.dataUrl, fileName: this.fileName, declarationId: this.id})
            .then(() => {
              this.$notifications.info(`Fail ${this.fileName} on üles laetud`)
              this.loadDocuments()
              this.uploading = false
            })
            .catch(() => this.uploading = false)
        }).catch((e) => this.$notifications.warning(e))
      }
    },
    created() {
      this.loadDeclaration()
      this.loadDocuments()
      this.loadRaw()
    }
  }
</script>
